import { createContext } from 'react';

export const StepperContext = createContext<{ index: number } | undefined>(undefined);

export default StepperContext;
